module.exports = __webpack_public_path__ + "static/media/image_03.78fac970.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stories/image_03.png
// module id = 1520
// module chunks = 0